<div class="plot-card overflow-hidden">
    <canvas #weightCanvas></canvas>
</div>